import './index.scss';
import React, { useCallback, useEffect, useState } from 'react';
import {useDropzone} from "react-dropzone";
import axios from 'axios';
import Utils from '../../CourseApp/Helper/utils';
import {
    IconPlusSmallWhite,
    IconAttachmentFile,
    IconCross
 } from '../../icons/svgs';
import manager from '../../Manager';

function AttachmentControl({structure, saveValue, defaultValue, controlKey, selectedSlide, runtimeValue}) {
    const [controlValue, setControlValue] = useState(defaultValue ?? {});

    const controlRules = structure?.rules;
    const controlRulesAllowedFileType = controlRules.allowedFileType ? controlRules.allowedFileType : ['.pdf'];
    const controlRulesMaxFileSize = controlRules.maxFileSize;
    const fileManagerUrl = manager.settings.filemanagerUrl;
    const tempUploadUrl = fileManagerUrl + '/temp';


    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        const validExtensions = controlRulesAllowedFileType;

        // Validasi tipe file
        const fileExtension = '.'+ file.name.split('.').pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
            Utils.showError('allowed file type .'+validExtensions);
            return;
        }

        // validate file size
        if (file.size > controlRulesMaxFileSize) {
            Utils.showError('Maximum file size: '+Utils.convertBytes(controlRulesMaxFileSize));
          return;
        }
        uploadFile(file);
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
        maxFiles:1,
        accept: {
            'application/pdf': ['.pdf'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            'application/vnd.ms-powerpoint': ['.ppt'],
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/zip': ['.zip'],
            'application/vnd.rar': ['.rar'],
        }
    });

    const uploadFile = (file) => {
        const formData = new FormData();
        formData.append('file', file);

        axios
          .post(tempUploadUrl, formData)
          .then((response) => {
            let responseData = response.data;
            let errCode = responseData.errCode;
            let errMessage = responseData.errMessage;
            let data = responseData.data;
            if (errCode > 0) {
                Utils.showError(errMessage);
            }
            if (errCode === 0) {
                let fileUploaded = data.file[0];
                // let fileId = fileUploaded.fileId;
                // let fileName = fileUploaded.filename;
                // let fullUrl = fileUploaded.fullUrl;
                // let size = fileUploaded.size;
                // let type = fileUploaded.type;
                setControlValue(fileUploaded);
                saveValue(fileUploaded);
            }
          })
        .catch((error) => {
            Utils.showError('An error occurred while uploading the file:'+ error);
        });
    };

    const handleRemove = () => {
        // setUploadedFile(null);

        setControlValue({});
        saveValue({});
        Utils.showSuccess('File removed');
    }

    useEffect(()=>{
        if(typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue({});
        }
    }, [defaultValue]);

    return (
        <div className="tbcourse-editor-control-attachment">
            {Object.keys(controlValue).length === 0 ? (
                <div {...getRootProps()} className='dropzone-wrapper'>
                    <input {...getInputProps()} />
                    <div className='upload-area'>
                        <IconPlusSmallWhite/>
                    </div>
                </div>
            ): (
                <div className='upload-preview'>
                    <div className='preview-actions'>
                        <button type="button" className="btn btn-remove remove" onClick={handleRemove}>
                            <IconCross/>
                        </button>
                    </div>
                    <div className='file-icon'>
                        <div className='file-icon-box'>
                            <IconAttachmentFile/>
                        </div>
                    </div>
                    <div className='file-info'>
                        <div className='file-name' title={controlValue?.filename}>{controlValue?.filename}</div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default AttachmentControl;
